export class SubmissionState{
    loading: boolean;
    submittingAppData: boolean;
    savingAppData: boolean;
    preparingPayment: boolean;
    completingPayment: boolean;
    paymentComplete: boolean;
    paymentFailed: boolean;
    validatingRequest: boolean;

    constructor() {
        this.loading = false;
        this.submittingAppData = false;
        this.savingAppData = false;
        this.preparingPayment = false;
        this.completingPayment = false;
        this.paymentComplete = false;
        this.paymentFailed = false;
        this.validatingRequest = false;
    }
}